import styled, { css } from 'styled-components';

export const Checkbox = styled.div`
  
  width: 100%;
  height:100%;
  display: flex;
  flex-direction: row;
  align-items: center;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

`

export const Box = styled.div`

  width:18px;
  height:18px;
  display: flex;

  justify-content: center;
  align-items: center;

  border:solid;
  border-width:1.5px;
  border-radius:1rem;
  padding:2px;
  margin-right:9px;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

  :hover{
    transform: scale(1.1,1.1);
    transition: transform .3s;
  }
  :not(:hover){
    transform: scale(1,1);
    transition: transform .3s;
  }

  ${
    (props)=> props.checked?
    css`
    .Check{
      display:block;
      background-color:${props.color??'#013457'};
    }
    border-color: ${props.color??'#013457'};
    `
    :
    css`
    border-color: #d9d9d9;
    .Check{
      animation: unchecking .2s;
      // display:none;
      background-color:${props.color??'#013457'};
    }`
  }

`

export const Check = styled.div`
  border-radius:50%;

  animation: checking .2s;
  animation-fill-mode: both;

  @keyframes checking{
    0% {
      width:0%;
      height:0%;
     }
    50%{
      width:50%;
      height:50%;
     }
    100%{
      width:100%;
      height:100%;
     }
  };

  @keyframes unchecking{
    100% {
      width:0%;
      height:0%;
     }
    50%{
      width:50%;
      height:50%;
     }
    0%{
      width:100%;
      height:100%;
     }
  };

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

`

export const Label = styled.label`

  font-size: 12.5px;
  ${(props)=> props.invalid ? css`color:#EE4245;`: css`color: #7a7a7a;`}
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;

`
